export class ImportSyncMedicineGridModel {
  public importedMedicineId: number;
  public importedMedicineName: string;
  public importedAdditionalTitle: string;
  public importedDataStatusId: number;
}